import { FC } from 'react';
import { useBreakpoint } from '@brg/ui';
import {  API, Competition } from '@brg/api';
import { useTranslation } from 'react-i18next';
import { LayoutConst, ModalControllerContainer } from 'core';
import {
    Wrapper , 
    ContentContainer
} from '../styles';
import ApplicationFormContent from "./applicationFormContent";
import GREEN_AWARD_FORMS from "./greenAwardForms";

/**
 * @param Модалка для конкурса 1635cbc48d0a4d8aab84f91cfa66afa6 @Artem
 */

export const ApplicationFormTemplate: FC<{
    projects: string[],
    competitionId?: string,
    nominationIds: string[],
    callback: () => void
    }> =
    ({projects, nominationIds, competitionId, callback }) => {
    const { t, i18n: { language } } = useTranslation();
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 );

    return <ModalControllerContainer>
        <Wrapper direction='column' style={{ margin: isMobile ? '12px auto' : '88px auto', overflowY: "auto", overflowX: 'hidden' }}>
            <ContentContainer>
                    <ApplicationFormContent
                        // @ts-ignore
                        data={API.toLang(GREEN_AWARD_FORMS[competitionId] || {}, language)} 
                        competitionId={competitionId} 
                        nominationIds={nominationIds} 
                    />
            </ContentContainer>
        </Wrapper>
    </ModalControllerContainer>

};
import { FC } from 'react';
import { useBreakpoint } from '@brg/ui';
import {  API, Competition } from '@brg/api';
import { useTranslation } from 'react-i18next';
import { LayoutConst, ModalControllerContainer } from 'core';
import {
    Wrapper , 
    ContentContainer
} from '../styles';
import ApplicationFormContent from "./applicationFormContent";
import GREEN_AWARD_FORMS from "./greenAwardForms";

/**
 * @param Модалка для конкурса 1635cbc48d0a4d8aab84f91cfa66afa6 @Artem
 */

export const ApplicationFormTemplate: FC<{
    projects: string[],
    competitionId?: string,
    nominationIds: string[],
    callback: () => void
    }> =
    ({projects, nominationIds, competitionId, callback }) => {
    const { t, i18n: { language } } = useTranslation();
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 );

    return <ModalControllerContainer>
        <Wrapper direction='column' style={{ margin: isMobile ? '12px auto' : '88px auto', overflowY: "auto", overflowX: 'hidden' }}>
            <ContentContainer>
                    <ApplicationFormContent
                        // @ts-ignore
                        data={API.toLang(GREEN_AWARD_FORMS[competitionId] || {}, language)} 
                        competitionId={competitionId} 
                        nominationIds={nominationIds} 
                    />
            </ContentContainer>
        </Wrapper>
    </ModalControllerContainer>

};
